import React from "react";
import { GeneralModal, useModalAlert } from "../GeneralComponents";

export function SubirDocument({
  openModal,
  handleCloseModal,
  documentoSeleccionado,
  loadRadicaciones
}) {
  const [formData, setFormData] = React.useState({
    documento_version: "",
  });
  const { showModalAlert } = useModalAlert();

  const newModalField = [
    {
      name: "documento_version",
      label: "Archivo Adjunto",
      type: "file",
      accept: ".pdf",
    },
  ];

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  async function handleSaveDocument(formData) {
    try {
      const fd = new FormData();
      const { documento_version, ...rest } = formData || {};

      // Attach file (handle File, FileList or array)
      if (documento_version) {
        let file = null;
        if (documento_version instanceof File) file = documento_version;
        else if (documento_version instanceof FileList)
          file = documento_version[0];
        else if (Array.isArray(documento_version) && documento_version.length)
          file = documento_version[0];

        if (file) fd.append("documento_version", file);
      }

      // Append any other remaining fields
      Object.keys(rest).forEach((key) => {
        if (rest[key] !== undefined && rest[key] !== null) {
          fd.append(
            key,
            typeof rest[key] === "object"
              ? JSON.stringify(rest[key])
              : String(rest[key])
          );
        }
      });

      // Append user and previous document as fields
      fd.append("id_gd_radicacion", documentoSeleccionado.id_gd_radicacion);

      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "documento-radicados/create",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
            // Do NOT set Content-Type; browser will set multipart/form-data with boundary
          },
          body: fd,
        }
      );

      const result = await updateResponse.json();
      handleCloseModal();
      if (updateResponse.ok) {
        showModalAlert("success", "Se actualizó correctamente la versión");
        loadRadicaciones()
      } else {
        showModalAlert(
          "danger",
          result?.message || "Error al actualizar la versión"
        );
      }
    } catch (error) {
      handleCloseModal();
      showModalAlert("danger", "Error al actualizar la versión");
      console.error(error);
    }
  }

  return (
    <>
      <GeneralModal
        open={openModal}
        titleAlert={"documento"}
        onClose={handleCloseModal}
        fields={newModalField}
        onFieldChange={handleFieldChange}
        onSave={handleSaveDocument}
        formData={formData}
        setFormData={setFormData}
        isUploadDoc={true}
        title={"Subir documento"}
      />
    </>
  );
}
